import React from "react";
import "../../Styles/certified/novin.css";

export default function Finzly() {
  return (
    <>
      <div className="novin-certified-details-section">
        <div className="novin-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="novin-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="novin-certified-details-left">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="novin-certified-badge"
            />
            <div className="novin-certified-company-names">
              <a href="https://www.novintix.com/" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/novintix/novin_logo.png"
                alt="Walkzero Logo"
                className="novin-certified-company-logo"
              />
            </a>
              <h1 className="novin-certified-full-name">
                NovintiX Technologies LLP
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="novin-certified-details-right">
            <img
              src="/assets/novintix/novin_1.jpeg"
              alt="Finzly Office"
              className="novin-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="novin-certified-description">
          <h2>
            Why   NovintiX Technologies LLP is an Outstanding Workplaces
          </h2>
          <p>
            A fast-growing engineering and digital transformation consultancy. They partner with global clients—primarily in the Life Sciences, MedTech, and Healthcare industries across the US, Europe, and India

          </p>
        </div>
        {/* Info Cards Section */}
        <div className="novin-certified-info-cards">
          <div className="novin-certified-info-card">
            <div className="novin-certified-info-title">COMPANY SIZE</div>
            <div className="novin-certified-info-value">130 Employees</div>
          </div>
          <div className="novin-certified-info-card">
            <div className="novin-certified-info-title">INDUSTRY</div>
            <div className="novin-certified-info-value">Medtech / life science and Healthcare. Also into digital transformation 

</div>
          </div>
          <div className="novin-certified-info-card">
            <div className="novin-certified-info-title">CONNECT</div>
            <div className="novin-certified-info-icons">
              <span className="novin-certified-icon-round">
                <a href="https://www.novintix.com/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="novin-certified-icon-round">
                <a href="https://www.linkedin.com/company/novintix/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="novin-certified-icon-round">
                <a href="https://www.facebook.com/novintix/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
            </div>
          </div>
          <div className="novin-certified-info-card">
            <div className="novin-certified-info-title">LOCATION (HQ)</div>
            <div className="novin-certified-info-value">Coimbatore</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="novin-certified-recognition-section">
          <h2 className="novin-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="novin-certified-recognition-badge">
            <img
              src="/june_2026.png"
              alt="Outstanding Workplaces Certified"
              className="novin-certified-recognition-image"
            />
          </div>
          <div className="novin-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Finzly Section */}
        <div className="novin-certified-life-section">
          <h2 className="novin-certified-life-title">
            Life at NovintiX Technologies LLP
          </h2>
          <div className="novin-certified-life-gallery">
            <div className="novin-certified-life-col">
              <img src="/assets/novintix/novin_6.jpeg" alt="Office 1" className="novin-certified-life-img" />
              <img src="/assets/novintix/novin_2.jpeg" alt="Team 1" className="novin-certified-life-img" />
            </div>
            <div className="novin-certified-life-col novin-certified-life-center">
              <img src="/assets/novintix/novin_3.jpeg" alt="Main Office" className="novin-certified-life-img novin-certified-life-img-large" />
            </div>
            <div className="novin-certified-life-col">
              <img src="/assets/novintix/novin_4.jpeg" alt="Office 2" className="novin-certified-life-img" />
              <img src="/assets/novintix/novin_5.jpeg" alt="Team 2" className="novin-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
